import { authApiService } from '@/api/authApiService';
import { ApiResponseType, BaseResponseType } from '@/types/sharedTypes';

export const deleteApiKeyApi = async (apiKeyId: string): Promise<ApiResponseType<BaseResponseType>> => {
  const uri = `/api-key/${apiKeyId}/`;

  return authApiService.DELETE(uri);
};
